import { render, staticRenderFns } from "./UserExport.vue?vue&type=template&id=ab2da59e&scoped=true"
import script from "./UserExport.vue?vue&type=script&lang=ts"
export * from "./UserExport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2da59e",
  null
  
)

export default component.exports